webpackJsonp([157154669668110],{

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(19);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DISPLAY_BOX_HEIGHT = 700;
	var SinglePortfolioTemplate = function SinglePortfolioTemplate(_ref) {
	  var data = _ref.data,
	      pathContext = _ref.pathContext;
	
	  //dynamically set the width of the image based on how tall it is to prevent scrolling.
	  var width = data.imageSharp.sizes.aspectRatio * DISPLAY_BOX_HEIGHT;
	  width = width > 1000 ? 1000 : width;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      style: {
	        margin: '2rem auto 0 auto',
	        left: '0',
	        right: '0',
	        width: width + 'px',
	        maxWidth: '100%'
	      }
	    },
	    _react2.default.createElement(_gatsbyImage2.default, { sizes: data.imageSharp.sizes })
	  );
	};
	
	exports.default = SinglePortfolioTemplate;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-single-portfolio-template-js-3ba2c9be4f05e49728e5.js